module.exports = __webpack_public_path__ + "static/assets/6337c459db67a8bdb679b2114431e67a.svg";